import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { monthLabel } from "@/lib/timesheet";

export const ApprovalFilters = ({ search, onSearch, month, onMonth, months }) => (
  <div className="flex flex-wrap items-center gap-3 border-b border-border bg-secondary/20 px-5 py-3">
    <div className="relative w-full sm:w-64">
      <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <Input data-testid="approval-search-input" value={search} onChange={(e) => onSearch(e.target.value)} placeholder="Search by name" className="h-9 pl-9" />
    </div>
    <Select value={month} onValueChange={onMonth}>
      <SelectTrigger data-testid="approval-month-filter" className="h-9 w-full sm:w-48"><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All months</SelectItem>
        {months.map((m) => <SelectItem key={m} value={m}>{monthLabel(m)}</SelectItem>)}
      </SelectContent>
    </Select>
    {(search || month !== "all") && (
      <Button data-testid="approval-clear-filters" variant="ghost" size="sm" onClick={() => { onSearch(""); onMonth("all"); }}>Clear</Button>
    )}
  </div>
);
